import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription, filter } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-client-info-bar',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, TranslateModule],
    templateUrl: './client-info-bar.component.html',
    styleUrls: ['./client-info-bar.component.scss']
})
export class ClientInfoBarComponent implements OnInit, OnDestroy {
    private authService = inject(AuthService);
    private router = inject(Router);

    impersonatedClient: any;
    private routerSubscription?: Subscription;

    ngOnInit() {
        // Load initially
        this.loadImpersonatedClient();

        // Reload on every navigation
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.loadImpersonatedClient();
            });
    }

    ngOnDestroy() {
        this.routerSubscription?.unsubscribe();
    }

    loadImpersonatedClient() {
        this.impersonatedClient = this.authService.getImpersonatedClient();
    }

    exitImpersonation() {
        this.authService.clearImpersonation();
        this.router.navigate(['/admin/clients']);
    }
}
